<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Tambah Pegawai
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <div class="col"><h5>Tambah Pegawai</h5></div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabPanel"
          ref="myTabPanel"
          v-model:selected-index="tabPanelIndex"
          :data-source="tabData"
          :animation-enabled="true"
          item-title-template="title"
          item-template="currentTemplate"
          @title-click="onTabChanging"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #t1>
            <div
              ref="tab1Form"
              class="editors"
              style="padding-top: 25px"
              v-if="pegawaiDataSource"
            >
              <DxValidationGroup ref="refValidationGroup">
                <div class="row row-cols-1 row-cols-md-3">
                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="NIK"
                          placeholder="NIK"
                          v-model="pegawaiDataSource.nik"
                        >
                          <DxValidator>
                            <DxNumericRule message="NIK adalah angka" />
                          </DxValidator>
                        </DxTextBox>
                        <DxTextBox
                          ref="refNama"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Nama"
                          placeholder="Nama"
                          v-model="pegawaiDataSource.nama"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxTextBox>
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="No. KTP"
                          placeholder="No. KTP"
                          v-model="pegawaiDataSource.nik_ktp"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                            <DxPatternRule
                              message="No. KTP harus berupa angka dengan 16 digit"
                              pattern="^\d{16}$"
                            />
                          </DxValidator>
                        </DxTextBox>

                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Alamat"
                          placeholder="Alamat"
                          v-model="pegawaiDataSource.alamat"
                        >
                        </DxTextBox>

                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="No. Telp"
                          placeholder="No. Telp"
                          v-model="pegawaiDataSource.telp"
                        >
                        </DxTextBox>

                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Email"
                          placeholder="Email"
                          v-model="pegawaiDataSource.email"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                            <DxPatternRule
                              pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                            />
                          </DxValidator>
                        </DxTextBox>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxSelectBox
                          :dataSource="commonStore.agamaStore"
                          valueExpr="id"
                          displayExpr="nama"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Agama"
                          label="Agama"
                          v-model="pegawaiDataSource.agama_id"
                        >
                        </DxSelectBox>
                        <DxTextBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          label="Tempat lahir"
                          placeholder="Tempat lahir"
                          v-model="pegawaiDataSource.tempat_lahir"
                        >
                        </DxTextBox>
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl lahir"
                          label="Tgl lahir"
                          v-model="pegawaiDataSource.tgl_lahir"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxDateBox>

                        <DxSelectBox
                          :dataSource="jenisKelaminSource"
                          valueExpr="val"
                          displayExpr="nama"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Jenis Kelamin"
                          label="Jenis Kelamin"
                          v-model="pegawaiDataSource.jenis_kelamin"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxSelectBox>
                        <DxDateBox
                          ref="dateBoxTglMulaiBekerja"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl mulai bekerja"
                          label="Tgl mulai bekerja"
                          v-model="pegawaiDataSource.tgl_mulai_bekerja"
                        >
                          <DxValidator>
                            <DxRequiredRule />
                          </DxValidator>
                        </DxDateBox>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="editors-container">
                      <div class="left">
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl pengangkatan"
                          label="Tgl pengangkatan"
                          v-model="pegawaiDataSource.tgl_diangkat"
                        >
                        </DxDateBox>
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl pensiun"
                          label="Tgl pensiun"
                          v-model="pegawaiDataSource.pensiun_tgl"
                        >
                        </DxDateBox>
                        <DxSelectBox
                          :dataSource="commonStore.statusAktifStore"
                          valueExpr="id"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status aktif"
                          label="Status aktif"
                          v-model="pegawaiDataSource.status_aktif_id"
                        >
                        </DxSelectBox>
                        <DxDateBox
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          :display-format="'dd/MM/yyyy'"
                          :format="'dd/MM/yyyy'"
                          width="100%"
                          placeholder="Tgl non aktif"
                          label="Tgl non aktif"
                          v-model="pegawaiDataSource.tgl_non_aktif"
                        >
                        </DxDateBox>
                        <DxSelectBox
                          :dataSource="commonStore.statusStore"
                          valueExpr="val"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status IFG Life"
                          label="Status IFG Life"
                          v-model="pegawaiDataSource.pensiun_jiwasraya"
                        >
                        </DxSelectBox>
                        <DxSelectBox
                          :dataSource="commonStore.statusStore"
                          valueExpr="val"
                          displayExpr="nama"
                          :searchEnabled="true"
                          searchExpr="nama"
                          search-mode="startswith"
                          :styling-mode="stylingMode"
                          :label-mode="labelMode"
                          width="100%"
                          placeholder="Status IFG Mandiri"
                          label="Status IFG Mandiri"
                          v-model="pegawaiDataSource.ifg_mandiri_status"
                        >
                        </DxSelectBox>

                        <!-- <DxSelectBox
                        :dataSource="commonStore.statusStore"
                        valueExpr="val"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Status PPH"
                        label="Status PPH"
                        v-model="pegawaiDataSource.pph"
                      >
                      </DxSelectBox> -->

                        <!-- <DxSelectBox
                        :dataSource="commonStore.statusPtkpStore"
                        valueExpr="nama"
                        displayExpr="nama"
                        :searchEnabled="true"
                        searchExpr="nama"
                        search-mode="startswith"
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        width="100%"
                        placeholder="Status PTKP"
                        label="Status PTKP"
                        v-model="pegawaiDataSource.status_ptkp"
                      >
                      </DxSelectBox> -->

                        <!-- <DxDateBox
                        :styling-mode="stylingMode"
                        :label-mode="labelMode"
                        :display-format="'dd/MM/yyyy'"
                         :format="'dd/MM/yyyy'"
                        width="100%"
                        placeholder="Tgl pensiun"
                        label="Tgl pensiun"
                        v-model="pegawaiDataSource.pensiun_tgl"
                      >
                      </DxDateBox> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="center">
                  <label for="fileUploader">Foto profil pegawai:</label>
                  <DxFileUploader
                    ref="fileUploader"
                    accept="image/*"
                    upload-mode="useForm"
                    name="files"
                    multiple="false"
                    @value-changed="handleFileUploader($event)"
                  >
                  </DxFileUploader>
                </div>
              </DxValidationGroup>
              <div class="center">
                <DxButton
                  v-if="can('pegawai-create')"
                  @click="validateClick('t1', $event)"
                  icon="chevrondoubleright"
                  text="Selanjutnya"
                  styling-mode="outlined"
                  type="default"
                  class="validate"
                  style="float: right"
                  :icon-position="'right'"
                />
              </div>
            </div>
          </template>

          <template #t2>
            <DxDataGrid
              id="dataGridPph"
              :data-source="pphDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="onRowInserting"
              @row-updating="onRowUpdating"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection :mode="multiple" :showCheckBoxesMode="always" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <DxColumn
                data-field="status_hitung"
                caption="Status Hitung PPH"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.statusSource,
                }"
                :dataType="'boolean'"
                cell-template="templateStatus"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusStore"
                />
              </DxColumn>
              <DxColumn
                data-field="tgl"
                caption="Tgl"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <template #templateStatus="{ data }">
                <StatusTemplate :value="data.value" />
              </template>

              <DxColumn
                data-field="ptkp"
                caption="PTKP"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.statusPtkpSource,
                }"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="nama"
                  :data-source="commonStore.statusPtkpStore"
                />
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="ter"
                caption="TER PPH 21 (%)"
                :allowHeaderFiltering="false"
              />
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                @click="prevClick(0)"
                icon="chevrondoubleleft"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />

              <DxButton
                @click="validateClick('t2', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t3>
            <DxDataGrid
              id="dataGridPremi"
              :data-source="premiDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="onRowInserting"
              @row-updating="onRowUpdating"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection :mode="multiple" :showCheckBoxesMode="always" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />

              <DxColumn
                data-field="tgl"
                caption="Tgl"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <template #templateStatus="{ data }">
                <StatusTemplate :value="data.value" />
              </template>

              <DxColumn
                data-field="premi_jkk"
                caption="Premi JKK"
                :allowHeaderFiltering="false"
                data-type="number"
                :customize-text="commonFunction.formatNumberWithDots"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>
              <DxColumn
                data-field="premi_jkm"
                caption="Premi JKM"
                :allowHeaderFiltering="false"
                data-type="number"
                :customize-text="commonFunction.formatNumberWithDots"
                :editor-options="
                  commonFunction.editorOptionsFormatterSeparateTypingWithDots
                "
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                @click="prevClick(1)"
                icon="chevrondoubleleft"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />

              <DxButton
                @click="validateClick('t3', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t4>
            <DxDataGrid
              id="dataGridKeluarga2"
              :data-source="keluargaDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="id"
              @row-inserting="onRowInserting"
              @row-updating="onRowUpdating"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection :mode="multiple" :showCheckBoxesMode="always" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <dx-column
                data-field="keluarga_hub_id"
                caption="Hubungan Keluarga"
                sort-order="asc"
                data-type="number"
              >
                <DxLookup
                  :data-source="commonStore.keluargaHubStore"
                  value-expr="id"
                  display-expr="nama"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="status_tertanggung"
                caption="Status Tertanggung"
                data-type="boolean"
              >
                <DxLookup
                  :data-source="statusTertanggungSource"
                  value-expr="val"
                  display-expr="nama"
                />
              </dx-column>

              <dx-column
                data-field="nama"
                caption="Nama Anggota Keluarga"
                data-type="string"
              >
                <DxRequiredRuleDataGrid
              /></dx-column>

              <dx-column data-field="nik" caption="NIK" data-type="string">
              </dx-column>
              <!-- <dx-column
                data-field="pasangan_nik"
                caption="NIK Pegawai PDAM"
                data-type="string"
              >
                <DxNumericRuleDataGrid />
              </dx-column> -->
              <DxColumn
                data-field="pasangan_id"
                caption="NIK Pegawai PDAM"
                :allowHeaderFiltering="false"
                :allowFiltering="false"
              >
                <DxLookup
                  :data-source="pegawaiSource"
                  value-expr="id"
                  display-expr="display_expr"
                />
              </DxColumn>
              <!-- <dx-column
                data-field="pasangan_id"
                caption="ID PASANGAN"
                :visible="false"
                :form-item="{ visible: false }"
              >
              </dx-column> -->

              <DxColumn
                data-field="tempat_lahir"
                caption="Tempat Lahir"
                data-type="string"
              >
              </DxColumn>
              <dx-column
                data-field="tgl_lahir"
                caption="Tgl lahir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
              </dx-column>

              <dx-column
                data-field="perkawinan_status_id"
                caption="Status Perkawinan"
                data-type="boolean"
              >
                <DxLookup
                  :data-source="commonStore.perkawinanStatusStore"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>

              <dx-column
                data-field="jenis_kelamin"
                caption="Jenis kelamin"
                data-type="string"
              >
                <DxLookup
                  :data-source="jenisKelaminSource"
                  value-expr="val"
                  display-expr="nama"
                />
              </dx-column>
              <DxColumn
                data-field="pekerjaan"
                caption="Pekerjaan"
                data-type="string"
              ></DxColumn>
              <dx-column
                data-field="agama_id"
                caption="Agama"
                data-type="number"
              >
                <DxLookup
                  :data-source="commonStore.agamaStore"
                  value-expr="id"
                  display-expr="nama"
                />
              </dx-column>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                @click="prevClick(2)"
                icon="chevrondoubleleft"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />

              <DxButton
                @click="validateClick('t4', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t5>
            <DxDataGrid
              ref="dataGridRefKey"
              id="dataGridEdFormal"
              :data-source="pendidikanDataSource"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <DxPopup
                :show-title="true"
                title="Row in the editing state"
                :width="300"
                :height="525"
              />

              <DxSorting mode="multiple" />
              <dx-column
                data-field="status_penyesuaian"
                caption="Penyesuaian"
                data-type="boolean"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="statusPenyesuaianSource"
                />
                <!-- cell-template="penyesuaianTemplate" -->
              </dx-column>

              <dx-column
                data-field="tgl_penyesuaian"
                caption="Tgl Penyesuaian"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
              >
              </dx-column>

              <dx-column
                data-field="pendidikan_jenjang_id"
                caption="Jenjang Pendidikan"
                sort-order="asc"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="commonStore.pendidikanJenjangStore"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="institusi"
                caption="Institusi"
                data-type="string"
              >
                <DxRequiredRuleDataGrid
              /></dx-column>
              <dx-column
                data-field="fakultas"
                caption="Fakultas"
                data-type="string"
              >
              </dx-column>
              <dx-column
                data-field="jurusan"
                caption="Jurusan"
                data-type="string"
              >
              </dx-column>
              <dx-column data-field="ipk" caption="IPK" data-type="string">
              </dx-column>
              <dx-column
                data-field="tahun_mulai"
                caption="Tahun Mulai"
                data-type="number"
              >
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column
                data-field="tahun_lulus"
                caption="Tahun Lulus"
                data-type="number"
              >
                <DxPatternRule :pattern="patternTahun" message="Tahun salah" />
              </dx-column>
              <dx-column
                data-field="ijazah_no"
                caption="No. Ijazah"
                data-type="string"
              >
              </dx-column>

              <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <!-- <DxPatternRule
                  :pattern="patternDMY"
                  message="Format tgl dd-mm-yyyy!"
                /> -->

                <!-- <DxPatternRule
                  :pattern="pattern"
                  message='Your phone must have "(555) 555-5555" format!'
                /> -->
              </dx-column>

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :validationRules="[
                  {
                    type: 'pattern',
                    pattern:
                      /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
                    message: 'Tanggal must be in the format dd-mm-yyyy',
                  },
                ]"
              >
              </dx-column> -->

              <!-- <dx-column
                data-field="ijazah_tgl"
                caption="Tgl Ijazah"
                data-type="date"
                :format="'dd-MM-yyyy'"
                :editor-options="editorOptions"
              >
              </dx-column> -->
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(3)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t5', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t6>
            <DxDataGrid
              ref="dataGridRefKey"
              id="dataGridPenghargaan"
              :data-source="penghargaanDataSource"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <DxPopup
                :show-title="true"
                title="Row in the editing state"
                :width="300"
                :height="525"
              />

              <DxSorting mode="multiple" />

              <DxColumn
                data-field="jenis"
                caption="Jenis Penghargaan"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.jenisPenghargaanSource,
                }"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="nama"
                  :data-source="commonStore.jenisPenghargaanStore"
                />
              </DxColumn>

              <DxColumn
                data-field="nama"
                caption="Nama Penghargaan"
                :allowHeaderFiltering="false"
              >
                <DxRequiredRuleDataGrid
              /></DxColumn>
              <DxColumn
                data-field="nomor"
                caption="No. Penghargaan"
                :allowHeaderFiltering="false"
              >
                <DxRequiredRuleDataGrid
              /></DxColumn>

              <DxColumn
                data-field="tgl"
                caption="Tgl Penghargaan"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="pemberi"
                caption="Pemberi Penghargaan"
                :allowHeaderFiltering="false"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="ket"
                caption="Keterangan"
                :allowHeaderFiltering="false"
              >
              </DxColumn>
            </DxDataGrid>

            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(4)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t6', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t7>
            <DxDataGrid
              ref="dataGridRefKey"
              id="dataGridPeringatan"
              :data-source="peringatanDataSource"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="10" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <DxPopup
                :show-title="true"
                title="Row in the editing state"
                :width="300"
                :height="525"
              />

              <DxSorting mode="multiple" />

              <DxColumn
                data-field="tingkatan_peringatan"
                caption="Tingkatan Peringatan"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.tingkatanPeringatanSource,
                }"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.tingkatanPeringatanStore"
                />
                <DxRequiredRuleDataGrid />
              </DxColumn>
              <DxColumn
                data-field="no_peringatan"
                caption="No. Surat Peringatan"
                :allowHeaderFiltering="false"
              >
                <DxRequiredRuleDataGrid
              /></DxColumn>

              <DxColumn
                data-field="tgl_peringatan"
                caption="Tgl Surat Peringatan"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="no_pemeriksaan"
                caption="No. Surat Laporan Pemeriksaan"
                :allowHeaderFiltering="false"
              />

              <DxColumn
                data-field="tgl_pemeriksaan"
                caption="Tgl Surat Laporan Pemeriksaan"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
              >
              </DxColumn>

              <DxColumn
                data-field="jenis_hukuman"
                caption="Jenis Hukuman"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.jenisHukumanSource,
                }"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.jenisHukumanStore"
                />
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="peringatan"
                caption="Isi Peringatan"
                :allowHeaderFiltering="false"
              >
                <DxRequiredRuleDataGrid
              /></DxColumn>
            </DxDataGrid>

            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(5)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t7', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t8>
            <DxDataGrid
              ref="refDataGridPekerjaan"
              id="dataGridPekerjaan"
              :data-source="pekerjaanDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              @init-new-row="initNewRowPekerjaan"
              @editor-preparing="onEditorPreparingRiwayatPekerjaan($event)"
              @row-updating="onUpdating($event, true)"
              @row-inserting="onInserting($event, true)"
            >
              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <!-- <dx-column
                data-field="status"
                caption="Status"
                :dataType="'boolean'"
                cell-template="templateStatus"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="statusSource"
                />
              </dx-column> -->
              <template #templateStatus="{ data }">
                <StatusTemplate :value="data.value" />
              </template>

              <dx-column
                data-field="no_sk"
                caption="No. SK"
                :dataType="'string'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl_sk"
                caption="Tgl SK"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="cabang_id"
                caption="Cabang"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="commonStore.cabangStore"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column data-field="unit_id" caption="Unit" data-type="number">
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.unitStore)
                  "
                />
              </dx-column>

              <dx-column
                data-field="pegawai_status_id"
                caption="Status Pegawai"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="commonStore.pegawaiStatusStore"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <DxColumn
                data-field="status_jabatan"
                caption="Status Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{
                  dataSource: commonStore.statusJabatanSource,
                }"
                default-value="Definitif"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="nama"
                  :data-source="commonStore.statusJabatanStore"
                />
                <DxRequiredRuleDataGrid />
              </DxColumn>

              <dx-column
                data-field="jabatan_id"
                caption="Jabatan"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="commonStore.jabatanStore"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <DxColumn
                data-field="koor"
                caption="Koor. Pelaksana"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusKoorSource }"
                :visible="true"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusKoorStore"
                />
              </DxColumn>

              <dx-column
                data-field="bagian_id"
                caption="Bagian"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.bagianStore)
                  "
                />
              </dx-column>
              <dx-column
                data-field="sub_bagian_id"
                caption="Sub Bagian"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.subBagianStore)
                  "
                />
              </dx-column>

              <dx-column
                data-field="bidang_id"
                caption="Bidang"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.bidangStore)
                  "
                />
              </dx-column>

              <dx-column
                data-field="sub_bidang_id"
                caption="Sub Bidang"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.subBidangStore)
                  "
                />
              </dx-column>
              <dx-column
                data-field="seksi_id"
                caption="Seksi"
                data-type="number"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="id"
                  :data-source="
                    commonFunction.withNullOption(commonStore.seksiStore)
                  "
                />
              </dx-column>

              <dx-column
                data-field="tgl_mulai_bekerja"
                caption="Tgl Mulai"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl_akhir_bekerja"
                caption="Tgl Akhir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
              </dx-column>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(6)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t8', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t9>
            <DxDataGrid
              ref="refDataGridTransport"
              id="dataGridrTransport"
              :data-source="transportDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
            >
              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />

              <dx-column data-field="tipe" caption="Tipe" data-type="string">
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="plat_no"
                caption="No. Plat"
                data-type="string"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="tgl_awal"
                caption="Tgl Awal"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="tgl_akhir"
                caption="Tgl Akhir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
              >
              </dx-column>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(7)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t9', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>

          <template #t10>
            <p>
              Tgl Mulai Bekerja (berdasarkan Data Pegawai):
              <!-- {{ naikPangkatTglMulaiBekerja }} -->
              {{ formatDateDisplay(pegawaiDataSource.tgl_mulai_bekerja) }}
            </p>

            <DxDataGrid
              ref="refDataGridNaikPangkat"
              id="dataGridNaikPangkat"
              :data-source="naikPangkatDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="key"
              @saving="savingNaikPangkat"
              @editor-preparing="onEditorPreparing($event, 'naikPangkat')"
            >
              <!-- @row-inserting="onRowInsertingNaikPangkat" -->
              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <!-- <dx-column data-field="key" caption="Key"> </dx-column> -->
              <!-- <dx-column
                data-field="prediksi"
                caption="Prediksi"
                :dataType="'boolean'"
                cell-template="templatePrediksi"
              >
              </dx-column> -->

              <!-- <dx-column
                data-field="status"
                caption="Status"
                :dataType="'boolean'"
                cell-template="templateStatus"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="statusSource"
                />
              </dx-column> -->

              <template #templateCapeg="{ data }">
                {{ formatCheckbox(data, "80%") }}
              </template>

              <template #templateStatus="{ data }">
                <StatusTemplate :value="data.value" />
              </template>
              <dx-column
                data-field="no_sk"
                caption="No. SK"
                :dataType="'string'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl_sk"
                caption="Tgl SK"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl"
                caption="Tgl"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="golongan_id"
                caption="Golongan"
                data-type="numnber"
              >
                <DxLookup
                  :data-source="commonStore.golonganStore"
                  value-expr="id"
                  display-expr="nama"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>

              <DxColumn data-field="capeg" caption="Status Capeg">
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="commonStore.statusCapegStore"
                />
              </DxColumn>

              <!-- <DxColumn
                data-field="capeg"
                caption="Capeg"
                :data-type="'boolean'"
                cell-template="templateCapeg"
                :editor-options="columnEditorOptions"
                :show-editor-always="false"
              /> -->

              <dx-column
                data-field="tipe"
                caption="Naik Pangkat"
                :dataType="'string'"
              >
                <DxLookup
                  display-expr="val"
                  value-expr="val"
                  :data-source="tipeKpSource"
                />
                <DxRequiredRuleDataGrid />
              </dx-column>
              <DxColumn
                data-field="masa_kerja"
                caption="Masa Kerja (Tahun)"
                :customize-text="commonFunction.appendTahun"
                data-type="number"
                :editor-options="{ readOnly: false }"
              >
                <DxRequiredRuleDataGrid />
                <DxNumericRuleDataGrid />
              </DxColumn>
              <DxColumn
                data-field="masa_kerja_bulan"
                caption="Masa Kerja (Bulan)"
                :customize-text="commonFunction.appendBulan"
                data-type="number"
                :editor-options="{ readOnly: false }"
              >
                <DxRequiredRuleDataGrid />
                <DxNumericRuleDataGrid />
              </DxColumn>

              <DxColumn data-field="ket" caption="Ket." data-type="string">
              </DxColumn>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(8)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t10', $event)"
                icon="chevrondoubleright"
                text="Selanjutnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: right"
                :icon-position="'right'"
              />
            </div>
          </template>
          <template #t11>
            <p>
              Tgl Mulai Bekerja (berdasarkan Data Pegawai):
              <!-- {{ naikPangkatTglMulaiBekerja }} -->
              {{ formatDateDisplay(pegawaiDataSource.tgl_mulai_bekerja) }}
            </p>
            <!-- <DxButton
              @click="generateKGB()"
              icon="menu"
              text="generate kgb"
              type="default"
              styling-mode="outlined"
            /> -->

            <!-- <DxButton
              @click="saveKP"
              icon="save"
              text="Save KP"
              type="default"
            />

            <DxButton
              @click="tahunTambah('add')"
              icon="plus"
              text="Tahun"
              type="danger"
            /> -->
            <!-- <DxButton
              @click="tahunTambah('minus')"
              icon="minus"
              text="Tahun"
              type="danger"
            /> -->
            <!-- <DxButton
              @click="bulanUbah(10, 'naikPangkatDataSource')"
              icon="edit"
              text="Bulan Oktober"
              type="danger"
            />
            <DxButton
              @click="bulanUbah(4, 'naikPangkatDataSource')"
              icon="edit"
              text="Bulan April"
              type="danger"
            />
            <DxButton
              @click="hariTambah('add')"
              icon="plus"
              text="Hari"
              type="danger"
            />
            <DxButton
              @click="golUbah('add')"
              icon="plus"
              text="Gol"
              type="danger"
            />
            <DxButton
              @click="golUbah('minus')"
              icon="minus"
              text="Gol"
              type="danger"
            /> -->

            <!-- key-expr="id" -->
            <DxDataGrid
              ref="refDataGridKgb"
              id="dataGridKGB"
              :data-source="KGBDataSource"
              :focused-row-index="0"
              :show-borders="true"
              :show-column-lines="false"
              :focused-row-enabled="true"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              :allow-column-reordering="true"
              key-expr="key"
              @saving="savingKgb"
              @editor-preparing="onEditorPreparing($event, 'kgb')"
            >
              <!-- @row-inserting="onRowInsertingKGB" -->

              <dx-paging :page-size="numberingPageSize" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <dx-filter-row :visible="true" />

              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxSelection mode="multiple" /> -->

              <DxToolbar>
                <DxItem name="groupPanel" />

                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>

              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :mode="dxEditingMode"
                :new-row-position="bottom"
              />
              <DxSorting mode="multiple" />
              <!-- <dx-column data-field="key" caption="Key"> </dx-column> -->
              <!-- <dx-column
                data-field="prediksi"
                caption="Prediksi"
                :dataType="'boolean'"
                cell-template="templatePrediksi"
              >
              </dx-column> -->
              <!-- 
              <dx-column
                data-field="status"
                caption="Status"
                :dataType="'boolean'"
                cell-template="templateStatus"
              >
                <DxLookup
                  display-expr="nama"
                  value-expr="val"
                  :data-source="statusSource"
                />
              </dx-column> -->

              <dx-column
                data-field="no_sk"
                caption="No. SK"
                :dataType="'string'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>
              <dx-column
                data-field="tgl_sk"
                caption="Tgl SK"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <dx-column
                data-field="tgl"
                caption="Tgl"
                :dataType="'date'"
                :display-format="'dd/MM/yyyy'"
                editor-type="dxDateBox"
                :format="'dd/MM/yyyy'"
                sort-order="asc"
              >
                <DxRequiredRuleDataGrid />
              </dx-column>

              <!-- <template #templatePrediksi="{ data }">
                {{ formatCheckbox(data, "Prediksi KGB") }}
              </template> -->

              <DxColumn
                data-field="masa_kerja"
                caption="Masa Kerja (Tahun)"
                data-type="number"
                :editor-options="{ readOnly: false }"
                :customize-text="commonFunction.appendTahun"
              >
                <DxRequiredRuleDataGrid />
                <DxNumericRuleDataGrid />
              </DxColumn>

              <DxColumn
                data-field="masa_kerja_bulan"
                caption="Masa Kerja (Bulan)"
                data-type="number"
                :editor-options="{ readOnly: false }"
                :customize-text="commonFunction.appendBulan"
              >
                <DxRequiredRuleDataGrid />
                <DxNumericRuleDataGrid />
              </DxColumn>

              <DxColumn data-field="ket" caption="Ket." data-type="string">
              </DxColumn>
            </DxDataGrid>
            <div style="padding-top: 20px">
              <DxButton
                icon="chevrondoubleleft"
                @click="prevClick(9)"
                text="Sebelumnya"
                styling-mode="outlined"
                type="default"
                class="validate"
                style="float: left"
              />
              <DxButton
                @click="validateClick('t11', $event)"
                icon="save"
                text="Simpan Data"
                type="default"
                class="validate"
                style="float: right"
              />
            </div>
          </template>
        </DxTabPanel>
      </div>
    </div>

    <div class="content-block">
      <div class="row">
        <!-- <div class="editors"> -->
        <div class="editors-container">
          <div class="col" style="padding-left: 10px">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="dxEditingSource"
              valueExpr="val"
              displayExpr="nama"
              width="10%"
              label="Editing Mode"
              placeholder="Editing Mode"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              v-model="dxEditingMode"
            >
            </DxSelectBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxValidationGroup from "devextreme-vue/validation-group";
import * as commonFunction from "@/utils/common-function.js";
import auth from "../auth";
import { useCommonStore } from "@/stores/utility/common-store2";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import api from "@/api";
import can from "@/haspermission";
import StatusTemplate from "./StatusTemplate.vue";
import { API_BASE_URL } from "@/global-constants";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import router from "@/router";
import { DateTime } from "luxon";
import DxTabPanel from "devextreme-vue/tab-panel";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextBox from "devextreme-vue/text-box";
import axios from "axios";
// import DxTextArea from "devextreme-vue/text-area";
// import DxTagBox from "devextreme-vue/tag-box";
import DxDateBox from "devextreme-vue/date-box";
import DxButton from "devextreme-vue/button";

import {
  DxValidator,
  DxRequiredRule,
  DxNumericRule,
  DxPatternRule,
} from "devextreme-vue/validator";
import notify from "devextreme/ui/notify";
import service from "./pegawai-add-data.js";
import _ from "lodash";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxEditing,

  // DxSelection,
  DxExport,
  DxToolbar,
  DxLookup,
  DxItem,
  DxSorting,
  DxRequiredRule as DxRequiredRuleDataGrid,
  DxNumericRule as DxNumericRuleDataGrid,
  DxPopup,
} from "devextreme-vue/data-grid";
import DataSource from "devextreme/data/data_source";

function formatDateISO(dateOri, format = null) {
  if (dateOri instanceof Date && !isNaN(dateOri)) {
    const date = DateTime.fromJSDate(new Date(dateOri));
    if (format != null) return date.toFormat(format);
    else return date.toFormat("yyyy-MM-dd");
  } else {
    // Handle case where dateOri is not a valid Date object
    return "Invalid Date";
  }
}
// const dataGridRefKey = "myDataGrid";
export default {
  components: {
    DxValidationGroup,
    DxSelectBox,
    DxTextBox,
    // DxTextArea,
    // DxTagBox,
    DxDateBox,
    DxButton,
    DxValidator,
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxEditing,

    // DxSelection,
    DxExport,
    DxToolbar,
    DxLookup,
    DxItem,
    DxRequiredRule,
    DxNumericRule,
    DxRequiredRuleDataGrid,
    DxNumericRuleDataGrid,
    DxPatternRule,
    DxSorting,
    DxFileUploader,
    StatusTemplate,
    DxPopup,
  },
  setup() {
    const pegawaiListStore = usePegawaiListStore();
    const commonStore = useCommonStore();
    // const statusAktifStore = useStatusAktifStore();
    return {
      commonStore,
      pegawaiListStore,
      commonFunction,
      // statusAktifStore,
    };
    // const picture = "images/employees/06.png";
    // const imageUrl = `https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/${picture}`;
  },

  data() {
    return {
      disableRiwayatPekerjaanConfig: [
        {
          jabatan_id: 1, //dirut
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 2, //dirum
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 3, //dirtek
          disableFields: [
            "unit_id",
            "cabang_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 1, koor: false },
        },
        {
          jabatan_id: 4, //kacab
          disableFields: [
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 5, //kabag
          disableFields: [
            "cabang_id",
            "unit_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 6, //kabid
          disableFields: [
            "cabang_id",
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 7, //kepala seksi
          disableFields: [
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 8, //kasubag
          disableFields: [
            "cabang_id",
            "unit_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
        {
          jabatan_id: 9, //kepala unit
          disableFields: [
            "bagian_id",
            "sub_bagian_id",
            "bidang_id",
            "sub_bidang_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { pegawai_status_id: 2 },
        },
        {
          jabatan_id: 10, //kasubid
          disableFields: [
            "cabang_id",
            "unit_id",
            "bagian_id",
            "sub_bagian_id",
            "seksi_id",
            "pegawai_status_id",
          ],
          defaultFields: { cabang_id: 1, pegawai_status_id: 2 },
        },
      ],

      dxEditingMode: "popup", //popup or row
      dxEditingSource: [
        { val: "row", nama: "Baris" },
        { val: "popup", nama: "Form popup" },
      ],
      columnEditorOptions: { enableThreeStateBehavior: false },
      router: router,
      ptkpSource: [
        { val: null },
        { val: "TK" },
        { val: "K0" },
        { val: "K1" },
        { val: "K2" },
        { val: "K3" },
      ],
      naikPangkatTglBeforeEdit: null,
      naikPangkatTglMulaiBekerja: "",
      patternDMY: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-[0-9]{4}$/,
      editorOptions: { mask: "99-99-9999", useMaskBehavior: true },
      pattern: /^\(\d{3}\) \d{3}-\d{4}$/i,
      patternTahun: /^\d{4}$/i,
      patternNumeric: /^\d+(?:[.,]\d+)?$/,

      pendidikanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      peringatanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      penghargaanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      naikPangkatDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      KGBDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),
      // naikPangkatDataSource: [
      //   {
      //     key: 1,
      //     masa_kerja: 7,
      //     ket: "hello",
      //   },
      // ],
      transportDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),
      pekerjaanDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [
            // {
            //   key: 1,
            //   pegawai_status_id: 2,
            //   jabatan_id: 12,
            //   cabang_id: 1,
            //   tgl_mulai_bekerja: "2023-04-03",
            // },
          ],
        },
      }),

      keluargaDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      pphDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),
      premiDataSource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      tabPanelIndex: 0,

      // pegawaiIdSource: null,

      jenisKelaminSource: [
        { val: "L", nama: "Laki-Laki" },
        { val: "P", nama: "Perempuan" },
      ],

      tabData: [
        {
          text: "Data Pegawai",
          template: "t1",
          disabled: false,
        },
        {
          text: "Data PPH",
          template: "t2",
          disabled: true,
        },
        {
          text: "Data Premi JKK & JKM",
          template: "t3",
          disabled: true,
        },
        {
          text: "Data Keluarga",
          template: "t4",
          disabled: true,
        },
        {
          text: "Riwayat Pendidikan",
          template: "t5",
          disabled: true,
        },
        {
          text: "Riwayat Penghargaan",
          template: "t6",
          disabled: true,
        },

        {
          text: "Riwayat Peringatan",
          template: "t7",
          disabled: true,
        },

        {
          text: "Riwayat Pekerjaan",
          template: "t8",
          disabled: true,
        },

        {
          text: "Riwayat Pemegang Kendaraan Dinas",
          template: "t9",
          disabled: true,
        },
        {
          text: "Kenaikan Pangkat",
          template: "t10",
          disabled: true,
        },
        {
          text: "KGB",
          template: "t11",
          disabled: true,
        },
      ],
      birthDate: new Date(1981, 5, 3),
      stylingMode: "underlined",
      pegawaiSource: null,
      //outlined, filled, underlined
      labelMode: "floating",
      text: "Olivia loves to sell. She has been selling DevAV products since 2012.",
      positions: service.getPositions(),
      states: service.getStates(),
      phoneRules: {
        X: /[02-9]/,
      },
      // pegawaiDataSource: {
      //   nik: null,
      //   nama: null,
      //   nik_ktp: null,
      //   tempat_lahir: null,
      //   tgl_lahir: null,
      //   telp: null,
      //   tgl_mulai_bekerja: null,
      //   tgl_diangkat: null,
      //   alamat: null,
      //   agama_id: null,
      //   pensiun_jiwasraya: null,
      //   ifg_mandiri_status: null,
      //   // pph: null,
      //   // status_ptkp: null,
      //   jenis_kelamin: null,
      //   pensiun_tgl: null,
      //   created_by_user_id: null,
      //   status_aktif_id: 1,
      //   tgl_non_aktif: null,
      // },

      pegawaiDataSource: {
        nik: null,
        nama: null,
        email: null,
        nik_ktp: null,
        tempat_lahir: null,
        tgl_lahir: null,
        telp: null,
        tgl_mulai_bekerja: null,
        tgl_diangkat: null,
        alamat: null,
        agama_id: 1, // Assuming 1 is the ID for Islam
        pensiun_jiwasraya: null,
        ifg_mandiri_status: null,
        // pph: null,
        // status_ptkp: null,
        jenis_kelamin: "L",
        pensiun_tgl: null,
        created_by_user_id: null,
        status_aktif_id: 1,
        tgl_non_aktif: null,
      },

      pegawai_foto: null,
      pegawai_foto_non_binary: null,
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],

      statusTertanggungSource: [
        { val: true, nama: "Tertanggung" },
        { val: false, nama: "" },
      ],
      focusedRowKeyKeluarga: 0,
      allowSaving: false,
      statusPenyesuaianSource: [
        { val: true, nama: "Penyesuaian" },
        { val: false, nama: "" },
      ],
      tipeKpSource: [
        { val: "Reguler" },
        { val: "Penyesuaian" },
        { val: "Pilihan" },
      ],
    };
  },

  async created() {
    await this.commonStore.preloadStores();
    let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
      {
        selector: "simpeg_pegawais.nama",
        desc: false,
      },
    ]);
    tempA.data.unshift({ id: null, display_expr: null });

    this.pegawaiSource = tempA.data; //all pegawai
  },

  async mounted() {
    // this.pegawaiIdSource = await this.fetchPegawaiIdSource();
    this.naikPangkatTglMulaiBekerja = this.formatDateDisplay(
      this.pegawaiDataSource.tgl_mulai_bekerja,
    );

    this.pegawaiDataSource.nik = await this.commonFunction.getNextNik();
  },
  watch: {
    "pegawaiDataSource.tgl_mulai_bekerja": function (newDateValue) {
      this.naikPangkatTglMulaiBekerja = this.formatDateDisplay(newDateValue);

      // Perform any other actions you need with the updated date value
    },
    "pegawaiDataSource.tgl_lahir"(newDateValue) {
      if (newDateValue) {
        const isoDate = DateTime.fromJSDate(newDateValue).toISODate();
        this.pegawaiDataSource.pensiun_tgl =
          this.commonFunction.hitungTglPensiun(isoDate);
      } else {
        this.pegawaiDataSource.pensiun_tgl = null;
      }
    },
  },

  methods: {
    onEditorPreparingRiwayatPekerjaan(e) {
      if (e.parentType == "filterRow" && e.allowHeaderFiltering) {
        e.editorName = "dxTextBox";
        e.editorOptions.disabled = true;
        e.allowFiltering = false;
      }

      if (e.parentType === "dataRow") {
        const disableRiwayatPekerjaanConfig =
          this.disableRiwayatPekerjaanConfig;

        // Handle jabatan change
        if (e.dataField === "jabatan_id") {
          const defaultHandler = e.editorOptions.onValueChanged;

          e.editorOptions.onValueChanged = (args) => {
            if (defaultHandler) defaultHandler(args);

            const grid = e.component;
            const rowIndex = e.row.rowIndex;
            const value = args.value;

            grid.cellValue(rowIndex, "jabatan_id", value);

            const rule = disableRiwayatPekerjaanConfig.find(
              (r) => r.jabatan_id === value,
            );

            if (rule) {
              // 👉 clear all disabled fields
              rule.disableFields.forEach((field) => {
                grid.cellValue(rowIndex, field, null);
              });
              // // 2. apply default fields 🔥
              if (rule.defaultFields) {
                Object.keys(rule.defaultFields).forEach((field) => {
                  // grid.cellValue(rowIndex, field, rule.defaultFields[field]);
                  const value = rule.defaultFields[field];
                  grid.cellValue(rowIndex, field, value);
                  console.log("apply default field", field, value);

                  // 🔥 important: sync editor if currently preparing this field
                  if (e.dataField === field) {
                    e.setValue(value);
                  }
                });
              }
            }

            grid.repaint();
          };
        }

        // 👉 Disable + force null (important!)
        if (e.row?.data?.jabatan_id != null) {
          const rule = disableRiwayatPekerjaanConfig.find(
            (r) => r.jabatan_id === e.row.data.jabatan_id,
          );

          if (rule && rule.disableFields.includes(e.dataField)) {
            e.editorOptions.disabled = true;

            // 🔥 ensure value is null (for existing data case)
            if (
              e.row.data[e.dataField] !== null &&
              !(e.dataField in rule.defaultFields)
            ) {
              e.setValue(null);
            }
          }
        }
      }
    },

    onInserting(e, fromRiwayatPekerjaan = false) {
      if (fromRiwayatPekerjaan) this.applyDefaults(e.data);
    },

    onUpdating(e, fromRiwayatPekerjaan = false) {
      if (fromRiwayatPekerjaan) {
        this.applyDefaults(e.newData, e.oldData);
      }
    },

    applyDefaults(data, oldData = {}) {
      console.log("applyDefaults", data, oldData);
      const jabatan = data.jabatan_id ?? oldData.jabatan_id;

      const rule = this.disableRiwayatPekerjaanConfig.find(
        (r) => r.jabatan_id === jabatan,
      );

      if (rule?.defaultFields) {
        Object.keys(rule.defaultFields).forEach((field) => {
          if (data[field] == null) {
            data[field] = rule.defaultFields[field];
          }
        });
      }
    },

    formAddedManualValidation() {
      if (
        this.pegawaiDataSource.status_aktif_id > 2 &&
        this.pegawaiDataSource.tgl_non_aktif === null
      ) {
        notify(
          "Pegawai sudah tidak aktif, silahkan isi tanggal non aktif",
          "error",
        );
        return false;
      }

      if (
        this.pegawaiDataSource.status_aktif_id === 2 &&
        this.pegawaiDataSource.tgl_non_aktif !== null
      ) {
        notify(
          "Status Pegawai adalah Pensiun, tanggal non aktif tidak boleh diisi",
          "error",
        );
        return false; //pensiun, harusnya tidak ada tgl non aktif
      }

      if (
        this.pegawaiDataSource.status_aktif_id === 2 &&
        this.pegawaiDataSource.pensiun_tgl === null
      ) {
        notify(
          "Status Pegawai adalah Pensiun, tanggal pensiun harus diisi",
          "error",
        );
        return false; //pensiun, harusnya ada tgl pensiun
      }

      return true;
    },

    async onTabChanging(e) {
      const result = this.$refs.refValidationGroup.instance.validate();
      //

      if (result.isValid) {
        if (!this.formAddedManualValidation()) {
          // Set all tabData rows disabled = true, except for row 0
          this.tabData.forEach((tab, idx) => {
            tab.disabled = idx !== 0 ? true : false;
          });

          return;
        }
        if (e.itemIndex > 0) this.tabData[e.itemIndex + 1]["disabled"] = false;
        return;
      } else {
        this.tabData.forEach((tab, idx) => {
          tab.disabled = idx !== 0 ? true : false;
        });
      }
    },
    initNewRowPekerjaan(e) {
      e.data.status_jabatan = "Definitif";
    },
    hitungMasaKerja(val) {
      const tglMulaiBekerja = DateTime.fromJSDate(
        new Date(this.pegawaiDataSource.tgl_mulai_bekerja),
      ).set({ day: 1 });

      const tgl = DateTime.fromJSDate(new Date(val)).set({ day: 1 });

      const diff = tgl.diff(tglMulaiBekerja, ["years", "months"]);

      const years = Math.floor(diff.years); // Get full years
      const months = Math.floor(diff.months); // Get full months
      return { years: years, months: months };
    },
    hitungMasaKerjaKgb(tgl) {
      let masaKerja = this.hitungMasaKerja(tgl);
      let tglNaikPangkatC1 = null;
      const naikPangkatC1 = _.filter(
        this.naikPangkatDataSource.items(),
        (item) => item.golongan_id > 8,
      );
      if (naikPangkatC1.length > 0) {
        tglNaikPangkatC1 = _.minBy(
          naikPangkatC1,
          (item) => new Date(item.tgl),
        ).tgl;
      }
      if (tglNaikPangkatC1) {
        if (
          DateTime.fromJSDate(new Date(tgl)) >=
          DateTime.fromISO(tglNaikPangkatC1)
        )
          // .set({ day: 1 }) perlukah untuk argsvalue and tglnaikpangkatc1?
          masaKerja.years = masaKerja.years - 5;
      }

      masaKerja.years = masaKerja.years - 2;

      return masaKerja;
    },
    hitungMasaKerjaNaikPangkat(tgl, golonganId, capeg = false) {
      let masaKerja = this.hitungMasaKerja(tgl);

      if (capeg) masaKerja.years = 1; // jika capeg, masa kerja 1 tahun
      else {
        masaKerja.years = masaKerja.years - 2;
        if (golonganId > 8) {
          masaKerja.years = masaKerja.years - 5;
        }
      }

      return masaKerja;
    },

    onEditorPreparing(e, table = null) {
      if (table === "naikPangkat" || table === "kgb") {
        if (
          e.name === "tgl" ||
          e.name === "golongan_id" ||
          e.name === "capeg"
        ) {
          e.editorOptions.onValueChanged = async (args) => {
            e.component.cellValue(e.row.rowIndex, "masa_kerja", null);
            e.component.cellValue(e.row.rowIndex, "masa_kerja_bulan", null);

            if (!args.value) {
              e.setValue(args.value);
              e.component.cellValue(e.row.rowIndex, e.name, args.value);
              if (e.name !== "capeg") return;
            }
            let masaKerja = null;

            if (table === "kgb") {
              masaKerja = this.hitungMasaKerjaKgb(args.value); //pass tgl,
            }

            if (table === "naikPangkat") {
              masaKerja = this.hitungMasaKerjaNaikPangkat(
                e.name === "tgl"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "tgl"),
                e.name === "golongan_id"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "golongan_id"),
                e.name === "capeg"
                  ? args.value
                  : e.component.cellValue(e.row.rowIndex, "capeg"),
              );
            }

            e.component.cellValue(
              e.row.rowIndex,
              "masa_kerja",
              masaKerja.years,
            );
            e.component.cellValue(
              e.row.rowIndex,
              "masa_kerja_bulan",
              masaKerja.months,
            );
            e.setValue(args.value);
            // e.component.cellValue(e.row.rowIndex, "tgl", args.value);
            e.component.cellValue(e.row.rowIndex, e.name, args.value);
          };
        }
      }
    },
    // async savingPekerjaan(e) {
    // if (e.changes[0].type === "update") {
    //   var statusJabatanUpdated = "";
    //   if ("status_jabatan" in e.changes[0].data) {
    //     statusJabatanUpdated = e.changes[0].data.status_jabatan;
    //   } else {
    //     statusJabatanUpdated = _.filter(e.component.getDataSource().items(), {
    //       key: e.changes[0].key,
    //     });
    //     statusJabatanUpdated = statusJabatanUpdated[0].status_jabatan;
    //   }
    //   // if (
    //   //   !this.validateOnlyOneStatusAktifPekerjaan(e, statusJabatanUpdated)
    //   // ) {
    //   //   e.cancel = true;
    //   //   if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
    //   //     this.$refs.refDataGridPekerjaan.instance.cancelEditData();
    //   //   }
    //   //   notify(
    //   //     "Hanya ada satu status jabatan " +
    //   //       statusJabatanUpdated +
    //   //       " yang aktif",
    //   //     "error"
    //   //   );
    //   // }
    // }
    // },
    // async savingPekerjaan2(e) {
    //   if (
    //     //JIKA INSERT
    //     e.changes[0].type === "insert"
    //   ) {
    //     if (
    //       !this.validateOnlyOneStatusAktifPekerjaan(
    //         e,
    //         e.changes[0].data.status_jabatan
    //       )
    //     ) {
    //       e.cancel = true;
    //       if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
    //         this.$refs.refDataGridPekerjaan.instance.cancelEditData();
    //       }
    //       notify(
    //         "Hanya ada satu status jabatan " +
    //           e.changes[0].data.status_jabatan +
    //           " yang aktif",
    //         "error"
    //       );
    //       return;
    //     }
    //   } else if (e.changes[0].type === "update") {
    //     var statusJabatanUpdated = "";
    //     if ("status_jabatan" in e.changes[0].data) {
    //       statusJabatanUpdated = e.changes[0].data.status_jabatan;
    //     } else {
    //       statusJabatanUpdated = _.filter(e.component.getDataSource().items(), {
    //         key: e.changes[0].key,
    //       });
    //       statusJabatanUpdated = statusJabatanUpdated[0].status_jabatan;
    //     }
    //     // if (
    //     //   !this.validateOnlyOneStatusAktifPekerjaan(e, statusJabatanUpdated)
    //     // ) {
    //     //   e.cancel = true;
    //     //   if (this.$refs.refDataGridPekerjaan.instance.hasEditData()) {
    //     //     this.$refs.refDataGridPekerjaan.instance.cancelEditData();
    //     //   }
    //     //   notify(
    //     //     "Hanya ada satu status jabatan " +
    //     //       statusJabatanUpdated +
    //     //       " yang aktif",
    //     //     "error"
    //     //   );
    //     // }
    //   }
    // },
    validateOnlyOneStatusAktifPekerjaan(e, statusJabatan) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), {
          status: true,
          status_jabatan: statusJabatan,
        }),
      );
      let countStatusFromChanges = 0;

      if (e.changes[0] && typeof e.changes[0].data === "object") {
        if (
          //hanya ada status di changes
          "status" in e.changes[0].data &&
          !("status_jabatan" in e.changes[0].data)
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //ada status dan status_jabatan di changes
          "status" in e.changes[0].data &&
          "status_jabatan" in e.changes[0].data
        ) {
          if (e.changes[0].data.status) countStatusFromChanges = 1;
        }
        if (
          //hanya ada status_jabatan di changes
          "status_jabatan" in e.changes[0].data &&
          !("status" in e.changes[0].data)
        ) {
          countStatusFromChanges = parseInt(
            _.size(
              _.filter(e.component.getDataSource().items(), {
                id: e.changes[0].key,
                status: true,
              }),
            ),
          );
          //SEARCHING INSIDE DATASOURCE YANG LAMA, TO GET STATUS KARENA STATUS TIDAK ADA DALAM CHANGES
        }
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    onRowUpdating(e) {
      if (_.has(e.newData, "pasangan_id")) {
        if (_.isEmpty(e.newData.pasangan_nik)) {
          //else pasangan_nik empty
          e.newData.pasangan_id = null;
          e.newData.pasangan_nik = null;
        }
      } else {
        e.cancel = false;
        //("onrowupdating go ahead ga punya pasangan");
      }
    },
    onRowInserting(e) {
      // if (_.has(e.data, "pasangan_nik")) {
      //   if (!_.isEmpty(e.data.pasangan_id)) {
      //     ("onrowinsertng prevent karena punya pasangan");
      //     // const shouldCancel = this.cekPasanganIdAndInsert(e.data.pasangan_nik);
      //     // ("shouldcancel", shouldCancel);
      //     // if (shouldCancel === null) {
      //     //   e.cancel = true;
      //     //   notify("NIK pasangan tidak terdaftar.", "error");
      //     // } else {
      //     //   e.cancel = false;
      //     //   e.data.pasangan_id = shouldCancel;
      //     // }
      //   }
      // } else {
      //   e.cancel = false;
      //   ("onrowinserting go ahead ga punya pasangan");
      // }

      if (!_.has(e.data, "pasangan_nik")) {
        e.cancel = false;
      }
    },

    // cekPasanganIdAndInsert(pasanganNik) {
    //   // var a = _.find(this.pegawaiIdSource, { nik: pasanganNik });
    //   while (pasanganNik.length < 4) {
    //     pasanganNik = "0" + pasanganNik;
    //   }

    //   // var pasanganId = "0" + pasanganNik;
    //   const a = _.find(this.pegawaiIdSource, (g) => {
    //     return g.nik === pasanganNik;
    //   });

    //   const id = a ? a.id : null;
    //   return id;
    // },

    can,
    editingStartNaikPangkat(e) {
      this.naikPangkatTglBeforeEdit = e.data.tgl;
    },
    // savingNaikPangkat(e) {
    //   console.log("savingNaikPangkat", e);
    //   if (
    //     e.changes[0].type === "update" &&
    //     ("tgl" in e.changes[0].data || "golongan_id" in e.changes[0].data)
    //   ) {
    //     e.cancel = true;
    //     console.log("ada perubahan tgl/golongan_id");
    //     const rows = e.component.getVisibleRows();
    //     const targetDateOld = DateTime.fromISO(this.naikPangkatTglBeforeEdit);
    //     let gapYear, month, targetGol;
    //     if ("tgl" in e.changes[0].data) {
    //       const targetDateNew = DateTime.fromISO(e.changes[0].data.tgl); //FIXME: harusnya bandingkan dgn old tgl,
    //       //FIXME: harusnya bandingkan dgn old tgl,

    //       //FIXME: TAPI PENAMBAHAN DATA YANG BARU BERDASAKAN TGL BARU
    //       //FIXME: TGL LAMA DIPAKAI UNTUK MENCARI TGL YANG LAIN YANG SETELAH SI TANGGAL LAMA INI
    //       gapYear = targetDateNew;
    //       month = targetDateNew.month;
    //     }

    //     if ("golongan_id" in e.changes[0].data)
    //       targetGol = e.changes[0].data.golongan_id;

    //     let i = 1;
    //     rows.forEach((data) => {
    //       if (data.data.id == e.changes[0].key) return;
    //       let newDate = DateTime.fromISO(data.data.tgl);
    //       let pushData = {};

    //       if (newDate > targetDateOld) {
    //         console.log("=========================");
    //         if ("tgl" in e.changes[0].data) {
    //           gapYear = gapYear.plus({ years: 4 });
    //           gapYear = gapYear.set({ month: month });
    //           pushData["tgl"] = gapYear.toISODate();
    //         }
    //         if ("golongan_id" in e.changes[0].data) {
    //           if (targetGol < 19) targetGol++;
    //           pushData["golongan_id"] = targetGol;
    //           console.log("targetGol", targetGol);
    //         }
    //         console.log("pushData " + i, pushData);
    //         console.log("rows.data " + i, data);
    //         i++;
    //         e.changes.push({
    //           type: "update",
    //           key: data.key,
    //           // data: { ket: "please make it work" },
    //           data: pushData,
    //         });
    //         console.log("e.changes", e.changes);
    //       }
    //     });
    //   }
    //   e.cancel = false;
    // },

    formatDateDisplay(dateOri) {
      if (!dateOri) return "";
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("dd/MM/yyyy");
    },
    formatCheckbox(data, val, valFalse = null) {
      if (data.value) return val;
      else if (valFalse != null) return valFalse;
    },
    formatCapeg(data) {
      if (data.value) {
        return "80%";
      }
    },
    formatPrediksi(data) {
      if (data.value) {
        return "Prediksi KP";
      }
    },
    formatPenyesuaian(data) {
      if (data.value) {
        return "Penyesuaian Ijazah";
      }
    },
    generateKPUpdateDS(data) {
      this.naikPangkatDataSource
        .store()
        .insert(data)
        .then(() => {
          this.naikPangkatDataSource.reload();
        });
    },
    generateKGBUpdateDS(data) {
      this.KGBDataSource.store()
        .insert(data)
        .then(() => {
          this.KGBDataSource.reload();
        });
    },
    generateKP() {
      // instance.refresh();
      var riwayatPekerjaan = this.pekerjaanDataSourceIsValid("generate");
      if (!riwayatPekerjaan)
        notify(
          "Tidak dapat generate data KP karena pegawai adalah Honor/Kontrak",
          "error",
        );
      if (riwayatPekerjaan) {
        let statusPekerjaanId = _.get(riwayatPekerjaan, "pegawai_status_id");

        let kerjaBulan = formatDateISO(
          riwayatPekerjaan["tgl_mulai_bekerja"],
          "M",
        );
        let kerjaTahun = formatDateISO(
          riwayatPekerjaan["tgl_mulai_bekerja"],
          "yyyy",
        );
        if (kerjaBulan >= 5 && kerjaBulan <= 10) kerjaBulan = "10";
        else kerjaBulan = "04";

        let tglNaikPangkat = "";

        if (statusPekerjaanId == 5) {
          let capegAdalahTrue = true;
          for (let i = 0; i < 10; i++) {
            if (i == 0) kerjaTahun = parseInt(kerjaTahun, 10) + 3;
            else if (i == 1) kerjaTahun = parseInt(kerjaTahun, 10) + 1;
            else if (i == 2) kerjaTahun = parseInt(kerjaTahun, 10) + 3;
            else kerjaTahun = parseInt(kerjaTahun, 10) + 4;
            tglNaikPangkat = kerjaTahun + "-" + kerjaBulan + "-01";
            this.generateKPUpdateDS({
              prediksi: true,
              capeg: capegAdalahTrue,
              status_penyesuaian: false,
              tgl: tglNaikPangkat,
            });
            capegAdalahTrue = false;
          }
        } else {
          for (let i = 0; i < 10; i++) {
            kerjaTahun = parseInt(kerjaTahun, 10) + 4;
            tglNaikPangkat = kerjaTahun + "-" + kerjaBulan + "-01";

            this.generateKPUpdateDS({
              prediksi: true,
              capeg: false,
              status_penyesuaian: false,
              tgl: tglNaikPangkat,
            });
          }
        }
      }
    },
    generateKGB() {
      // var instance = this.$refs.refDataGridKGB.instance;
      // instance.refresh();
      var riwayatPekerjaan = this.pekerjaanDataSourceIsValid(1);
      if (!riwayatPekerjaan)
        notify(
          "Tidak dapat generate data KGB karena bukan pegawai tetap",
          "error",
        );
      if (riwayatPekerjaan) {
        let statusPekerjaanId = _.get(riwayatPekerjaan, "pegawai_status_id");
        if (statusPekerjaanId == 5) {
          notify(
            "Tidak dapat generate data KGB karena bukan pegawai tetap",
            "error",
          );
          return;
        }

        let kerjaBulan = formatDateISO(
          riwayatPekerjaan["tgl_mulai_bekerja"],
          "M",
        );
        let kerjaTahun = formatDateISO(
          riwayatPekerjaan["tgl_mulai_bekerja"],
          "yyyy",
        );

        let tglNaikGaji = "";
        let masaKerja = 5;
        for (let i = 0; i < 10; i++) {
          if (i == 0) kerjaTahun = parseInt(kerjaTahun, 10) + 1;
          //karena sudah dihitung 1tahun
          else kerjaTahun = parseInt(kerjaTahun, 10) + 2;
          tglNaikGaji = kerjaTahun + "-" + kerjaBulan + "-01";

          this.generateKGBUpdateDS({
            prediksi: true,

            tgl: tglNaikGaji,
            masa_kerja: masaKerja,
          });
          masaKerja += 2;
        }
      }
    },

    pekerjaanDataSourceIsValid(returnArray = null) {
      // const limitStatus = returnArray === "naikPangkat" ? 3 : 2;

      // const isHonorOrKontrak = _.filter(
      //   this.pekerjaanDataSource.items(),
      //   (item) => item.pegawai_status_id > 3 && item.status === true
      // );

      //==============BATAAASS

      var result = false;
      var limitStatus = 2; //direksi tetap
      if (returnArray === "naikPangkat") limitStatus = 3; //tambah capeg
      if (this.pekerjaanDataSource.items().length > 0) {
        const filteredData = _.filter(
          this.pekerjaanDataSource.items(),
          (item) => {
            const status = item.pegawai_status_id;
            return status < limitStatus; //direksi tetap capeg
          },
        );
        const orderedData = _.orderBy(
          filteredData,
          ["tgl_mulai_bekerja"],
          ["asc"],
        );

        if (filteredData.length > 0) {
          if (returnArray === "generate") return orderedData[0];
          result = true;
        }
      }

      return result;
    },

    // onRowInsertingKGB(e) {
    //   if (
    //     !this.pekerjaanDataSource ||
    //     this.pekerjaanDataSource.items().length === 0
    //   ) {
    //     notify(
    //       "Tidak dapat simpan data KGB karena tidak ada Riwayat Pekerjaan.",
    //       "error"
    //     );
    //     e.cancel = true;
    //     e.component.cancelEditData();
    //     return;
    //   } else {
    //     const isCapegOrHonorOrKontrak = _.filter(
    //       this.pekerjaanDataSource.items(),
    //       (item) =>
    //         item.pegawai_status_id > 2 &&
    //         item.status === true &&
    //         item.status_jabatan === "Definitif"
    //     ); //
    //     if (isCapegOrHonorOrKontrak.length > 0) {
    //       e.cancel = true;
    //       e.component.cancelEditData();
    //       notify(
    //         "Riwayat Pekerjaan yang aktif adalah Pegawai Capeg/Honor/Kontrak. Tidak memiliki KGB.",
    //         "error"
    //       );
    //       return;
    //     }
    //   }
    // },

    async savingNaikPangkat(e) {
      if (
        !this.pekerjaanDataSource ||
        this.pekerjaanDataSource.items().length === 0
      ) {
        notify(
          "Tidak dapat simpan data Kenaikan Pangkat karena tidak ada Riwayat Pekerjaan.",
          "error",
        );
        e.cancel = true;
        e.component.cancelEditData();
        return;
      }

      if (e.changes[0].type === "remove") {
        e.cancel = false;
        return;
      }

      const isDireksiOrTetapOrCapeg = _.filter(
        this.pekerjaanDataSource.items(),
        (item) =>
          item.pegawai_status_id < 4 && //1,2,3 adalah direksi tetap capeg
          item.status_jabatan === "Definitif",
      );
      if (isDireksiOrTetapOrCapeg.length === 0) {
        e.cancel = true;
        if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
          this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
        }
        notify(
          "PEKERJA HONOR/KONTRAK TIDAK MEMILIKI DATA NAIK PANGKAT. HANYA CAPEG/TETAP/DIREKSI YG DEFINITIF DAPAT MEMLIKI NAIK PANGKAT",
          "error",
        );
        return;
      }

      // if (!this.validateOnlyOneStatusAktif(e)) {
      //   e.cancel = true;
      //   if (this.$refs.refDataGridNaikPangkat.instance.hasEditData()) {
      //     this.$refs.refDataGridNaikPangkat.instance.cancelEditData();
      //   }
      //   notify("HANYA ADA SATU DATA KENAIKAN PANGKAT YANG AKTIF", "error");
      // }
    },

    async savingKgb(e) {
      if (
        !this.pekerjaanDataSource ||
        this.pekerjaanDataSource.items().length === 0
      ) {
        notify(
          "Tidak dapat simpan data KGB karena tidak ada Riwayat Pekerjaan.",
          "error",
        );
        e.cancel = true;
        e.component.cancelEditData();
        return;
      }

      if (e.changes[0].type === "remove") {
        e.cancel = false;
        return;
      }

      const isDireksiOrTetap = _.filter(
        this.pekerjaanDataSource.items(),
        (item) =>
          item.pegawai_status_id < 3 && //1,2 adalah direksi tetap
          item.status_jabatan === "Definitif",
      );
      if (isDireksiOrTetap.length === 0) {
        e.cancel = true;
        if (this.$refs.refDataGridKgb.instance.hasEditData()) {
          this.$refs.refDataGridKgb.instance.cancelEditData();
        }
        notify(
          "PEKERJA HONOR/KONTRAK TIDAK MEMILIKI DATA KGB. HANYA CAPEG/TETAP/DIREKSI YG DEFINITIF DAPAT MEMLIKI KGB",
          "error",
        );

        return;
      }

      // if (!this.validateOnlyOneStatusAktif(e)) {
      //   e.cancel = true;
      //   if (this.$refs.refDataGridKgb.instance.hasEditData()) {
      //     this.$refs.refDataGridKgb.instance.cancelEditData();
      //   }
      //   notify("HANYA ADA SATU DATA KGB YANG AKTIF", "error");
      // }
    },
    validateOnlyOneStatusAktif(e) {
      const countStatusFromDS = _.size(
        _.filter(e.component.getDataSource().items(), { status: true }),
      );
      let countStatusFromChanges = 0;

      if (
        e.changes[0] &&
        typeof e.changes[0].data === "object" &&
        "status" in e.changes[0].data
      ) {
        if (e.changes[0].data.status) countStatusFromChanges = 1;
      }

      const totalAktif =
        parseInt(countStatusFromChanges) + parseInt(countStatusFromDS);
      if (totalAktif > 1) return false; //TODO: artinya ada lebih dari 1 aktif
      return true;
    },

    onRowInsertingNaikPangkat(e) {
      if (
        !this.pekerjaanDataSource ||
        this.pekerjaanDataSource.items().length === 0
      ) {
        notify(
          "Tidak dapat simpan data Kenaikan Pangkat karena tidak ada Riwayat Pekerjaan.",
          "error",
        );
        e.cancel = true;
        e.component.cancelEditData();
        return;
      } else {
        const isHonorOrKontrak = _.filter(
          this.pekerjaanDataSource.items(),
          (item) =>
            item.pegawai_status_id > 3 &&
            item.status === true &&
            item.status_jabatan === "Definitif",
        ); //
        if (isHonorOrKontrak.length > 0) {
          e.cancel = true;
          e.component.cancelEditData();
          notify(
            "Riwayat Pekerjaan yang aktif adalah Pekerja Honor/Kontrak. Tidak memiliki Kenaikan Pangkat.",
            "error",
          );
          return;
        }
      }
    },

    namaPasanganBerubah(value, previousValue) {
      var valueLen = value.length - 1;
      var ubah = false;
      if ("pasangan_id" in value[valueLen]["data"]) {
        ubah = true;
        if (previousValue.length > 0) {
          //("previousValue length > 0 ubah false");
          ubah = false;
          if ("pasangan_id" in previousValue[0]["data"]) {
            if (
              _.get(value[valueLen]["data"], "pasangan_id") !==
              _.get(previousValue[0]["data"], "pasangan_id")
            ) {
              //("pasanganId lama != pasanganIdBaru ubah true");
              ubah = true;
            }
          }

          if (
            Object.keys(previousValue[0]["data"]).length === 1 &&
            "pegawai_id" in previousValue[0]["data"]
          ) {
            // The object only has the "pegawai_id" property
            //("only have pegawaiId ubah true");
            ubah = true;
          }
        }
      }

      return ubah;
    },

    handleClickDeletePasangan() {
      this.popupPasanganVisible = false;
      const dataGridInstance = this.$refs.dataGridrKeluargaRef.instance;
      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan.nik", "");

      dataGridInstance.cellValue(this.rKeluargaRowIndex, "pasangan_id", "");
      dataGridInstance.saveEditData();
    },
    handleClickPilihPasangan(data) {
      this.popupPasanganVisible = false;

      const dataGridInstance = this.$refs.dataGridrKeluargaRef.instance;
      // console.log(this.$refs.dataGridrKeluargaRef);

      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "pasangan.nik",
        data.data.nik,
      );
      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "nama",
        data.data.nama,
      );

      dataGridInstance.cellValue(
        this.rKeluargaRowIndex,
        "pasangan_id",
        data.data.id,
      );
      dataGridInstance.saveEditData();
    },

    handleFileUploader(e) {
      this.pegawai_foto = e.value[0];
      this.pegawai_foto_non_binary = e.value[0];
      let reader = new FileReader();
      reader.onloadend = () => {
        this.imagePreviewUrl = reader.result;
      };
      reader.readAsDataURL(this.pegawai_foto);
    },

    prevClick(tabSelected) {
      this.tabPanelIndex = _.parseInt(tabSelected);
    },

    validateClick(tabSelected) {
      // const result = e.validationGroup.validate();
      const result = this.$refs.refValidationGroup.instance.validate();

      if (result.isValid) {
        if (!this.formAddedManualValidation()) return;
        // notify("The task was saved successfully.", "success");
        //enable next step
        // const nextTab = _.parseInt(_.nth(tabSelected, 1));
        const match = tabSelected.match(/t(\d+)/); // Match "t" followed by digits
        const nextTab = match ? parseInt(match[1], 10) : null;
        this.tabPanelIndex = nextTab;
        // this.pegawais.tgl_lahir = formatDateISO(this.pegawais.tgl_lahir);
        if (nextTab < _.size(this.tabData)) {
          this.tabData[nextTab]["disabled"] = false;
          //("MASIH ADA NEXT TAB");
        }

        if (nextTab >= _.size(this.tabData)) {
          //ini tab terakhir

          if (this.validAllTabs()) {
            this.postDatabase();
          }
        }
        // this.$refs.myTabPanel.selectedIndex = nextTab;
      } else {
        notify(
          "The task was not saved. Please check if all fields are valid.",
          "error",
        );
      }
    },

    validAllTabs() {
      if (
        this.pendidikanDataSource.items().length == 0 ||
        this.pekerjaanDataSource.items().length == 0
      ) {
        notify("Data Pendidikan dan Pekerjaan tidak boleh kosong", "error");
        return false;
      }

      const isDireksiOrTetap = _.filter(
        this.pekerjaanDataSource.items(),
        (item) =>
          item.pegawai_status_id < 3 && item.status_jabatan === "Definitif",
      ); //id 1, 2
      const isDireksiOrTetapOrCapeg = _.filter(
        this.pekerjaanDataSource.items(),
        (item) =>
          item.pegawai_status_id < 4 && item.status_jabatan === "Definitif",
      ); // id 1,2,3

      if (
        this.naikPangkatDataSource.items().length == 0 &&
        isDireksiOrTetapOrCapeg.length > 0
      ) {
        //pegawai adalah direksi/tetap/capeg, maka harus ada kenaikan pangkat
        notify(
          "Riwayat Pekerjaan adalah Direksi/Pegawai Tetap/Capeg. Harus memiliki Kenaikan Pangkat.",
          "error",
        );
        return false;
      }

      if (
        this.KGBDataSource.items().length == 0 &&
        isDireksiOrTetap.length > 0
      ) {
        //pegawai adalah direksi/tetap, maka harus ada kgb. capeg enggak perlu punya kgb
        notify(
          "Riwayat Pekerjaan  adalah Direksi/Pegawai Tetap. Harus memiliki KGB.",
          "error",
        );
        return false;
      }

      const isRiwayatPekerjaanValid = _.filter(
        this.pekerjaanDataSource.items(),
        (item) => item.status_jabatan === "Definitif",
      );

      if (isRiwayatPekerjaanValid.length === 0) {
        notify("Riwayat Pekerjaan harus ada jabatan Definitif", "error");
        return false;
      }

      return true;
    },

    async postDatabase() {
      let checkNik = await this.pegawaiListStore.dataSourcePegawaiListCoba([
        "simpeg_pegawais.nik",
        "=",
        this.pegawaiDataSource.nik,
      ]); //ini akan return berupa array, bukan source

      if (this.pegawaiDataSource.nik && checkNik.totalCount > 0) {
        notify(
          "NIK sudah digunakan oleh pegawai lain (" +
            checkNik.data[0].nama +
            "), silakan ganti NIK",
          "error",
        );
        this.pegawaiDataSource.nik = null;
        return;
      }

      this.pegawaiDataSource.tgl_lahir = this.isDateValid(
        this.pegawaiDataSource.tgl_lahir,
      );
      this.pegawaiDataSource.created_by_user_id = auth.getUser().id;
      this.pegawaiDataSource.tgl_mulai_bekerja = this.isDateValid(
        this.pegawaiDataSource.tgl_mulai_bekerja,
      );
      this.pegawaiDataSource.tgl_diangkat = this.isDateValid(
        this.pegawaiDataSource.tgl_diangkat,
      );
      this.pegawaiDataSource.pensiun_tgl = this.isDateValid(
        this.pegawaiDataSource.pensiun_tgl,
      );
      this.pegawaiDataSource.tgl_non_aktif = this.isDateValid(
        this.pegawaiDataSource.tgl_non_aktif,
      );

      _.forEach(this.keluargaDataSource.items(), (row) => {
        row.tgl_lahir = this.isDateValid(row.tgl_lahir);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.pphDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.premiDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.pendidikanDataSource.items(), (row) => {
        row.tgl_penyesuaian = this.isDateValid(row.tgl_penyesuaian);
        row.ijazah_tgl = this.isDateValid(row.ijazah_tgl);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.peringatanDataSource.items(), (row) => {
        row.tgl_peringatan = this.isDateValid(row.tgl_peringatan);
        row.tgl_pemeriksaan = this.isDateValid(row.tgl_pemeriksaan);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.penghargaanDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.pekerjaanDataSource.items(), (row) => {
        row.tgl_mulai_bekerja = this.isDateValid(row.tgl_mulai_bekerja);
        row.tgl_sk = this.isDateValid(row.tgl_sk);
        row.tgl_akhir_bekerja = this.isDateValid(row.tgl_akhir_bekerja);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.transportDataSource.items(), (row) => {
        row.tgl_awal = this.isDateValid(row.tgl_awal);
        row.tgl_akhir = this.isDateValid(row.tgl_akhir);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.naikPangkatDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.tgl_sk = this.isDateValid(row.tgl_sk);
        row.created_by_user_id = auth.getUser().id;
      });

      _.forEach(this.KGBDataSource.items(), (row) => {
        row.tgl = this.isDateValid(row.tgl);
        row.tgl_sk = this.isDateValid(row.tgl_sk);
        row.created_by_user_id = auth.getUser().id;
      });

      const config = {
        headers: {
          // "content-type": "application/json",
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      // const self = this;

      try {
        const response = await axios.post(
          `${API_BASE_URL}/simpeg_pegawai/store`,
          {
            simpegPegawais: this.pegawaiDataSource,
            riwayatPendidikans: this.pendidikanDataSource.items(),
            riwayatKeluargas: this.keluargaDataSource.items(),
            pphs: this.pphDataSource.items(),
            premis: this.premiDataSource.items(),
            riwayatPekerjaans: this.pekerjaanDataSource.items(),
            pegawai_foto: this.pegawai_foto_non_binary,
            riwayatTransports: this.transportDataSource.items(),
            naikPangkats: this.naikPangkatDataSource.items(),
            kgbs: this.KGBDataSource.items(),
            riwayatPeringatans: this.peringatanDataSource.items(),
            riwayatPenghargaans: this.penghargaanDataSource.items(),
          },
          config,
        );

        if (response.data.status) {
          notify("Data Pegawai berhasil ditambahkan.", "success");
          const url = this.$router.resolve({
            name: "pegawai-detail-custom",
            query: { id: response.data.id },
          }).href;
          window.location.href = url;
        } else notify("Data Pegawai gagal ditambahkan.", "error");
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Data Pegawai gagal ditambahkan.", "error");
        return false; // If there was an error
      }

      // .then(function (res) {
      //   console.log("res", res);
      //   console.log("res.data", res.data);
      //   console.log("res.data.id", res.data.id);
      //   notify("Data Pegawai berhasil ditambahkan.", "success");

      //   const url = this.$router.resolve({
      //     name: "simpeg-pegawai-detail",
      //     query: { id: 1 },
      //   }).href;
      //   window.location.href = url;
      // })
      // .catch(function (err) {
      //   console.log(err);
      //   notify("Data Pegawai gagal ditambahkan.", "error");
      // });
    },

    isDateValid(dateOri) {
      if (!dateOri) {
        return dateOri;
      }
      if (dateOri instanceof Date) {
        // If it's a Date object, format it directly

        const luxonDate = DateTime.fromJSDate(dateOri);
        return luxonDate.toFormat("yyyy-MM-dd");
      }
      var format = "yyyy-MM-dd";
      const date = DateTime.fromFormat(dateOri, format);
      if (date.isValid && date.toFormat(format) === dateOri) {
        return dateOri;
      }

      const parsedDate = DateTime.fromFormat(dateOri, "dd/MM/yyyy");

      // Format the parsed date in the desired format "yyyy-MM-dd"
      return parsedDate.toFormat("yyyy-MM-dd");
    },
  },
};
</script>
<style>
.title {
  padding: 20px 0 20px 0;
  font-size: 18px;
  font-weight: 500;
}

.editors {
  /* margin-right: 320px; */
  height: 570px;
  width: 100%;
}

.editors .left {
  padding: 0 10px 0 0;
}

.editors .right {
  padding: 0 0 0 10px;
}

.editors .left,
.editors .right {
  flex-grow: 1;
}

.editors .left > *,
.editors .right > *,
.editors .center > * {
  margin-bottom: 20px;
}

.editors .center {
  padding: 0 27px 0 0;
}

.validate {
  float: right;
}

.options {
  padding: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 260px;
  top: 0;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-size: 18px;
  font-weight: 500;
}

.option {
  margin-top: 20px;
}

.editors-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 27px;
}
</style>
